import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Grupo } from 'src/app/model/index.model';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class GrupoService extends BaseService<Grupo> {

    constructor(protected override http: HttpClient) {
        super(http, 'grupo');
    }
}
